module.exports = __webpack_public_path__ + "static/media/finder.22f88db3.svg";